import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { ChecklistDataParams } from '../checklist-data.service';

@Component({
    selector: 'tt-checklist-data-view',
    templateUrl: './checklist-data-view.component.html',
    styleUrls: ['./checklist-data-view.component.css'],
})
export class ChecklistDataViewComponent {
    public params: ChecklistDataParams;

    public heading = '';

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as ChecklistDataParams;
    }

    onSubmit() {
        this.state.back();
    }
}
